import moment from "moment";
export  const DateFormat=(dateValue, dateFormat='MM-DD-YYYY')=>{
    if(dateValue){
        return moment.utc(dateValue).format(dateFormat);
    }else{
        return '';
    }
}